/* ============================================================
   Bundle V2 — Vanilla JS state machine
   No jQuery dependency.
   ============================================================ */

(function () {
  'use strict';

  const SLOT_COUNT = 4;

  /* ── State ──────────────────────────────────────────────── */
  const state = {
    /** @type {Array<null|{image:string,title:string,id12:string,id30:string}>} */
    slots: Array(SLOT_COUNT).fill(null),
    activeSlot: 0,
    packSize: '30',       // '12' | '30'
    offerType: 'onetime', // 'subscribe' | 'onetime'
    skio: { planId: '', discountPercent: 30 },
    /** @type {Object<string,{price:number,compareAtPrice:number,sachets:number,size:string,title:string}>} */
    variants: {},
  };

  /* ── DOM cache ──────────────────────────────────────────── */
  let container, gallerySlots;
  let builderSlots, counterEl;
  let flavourItems;
  let offerCards, sellingPlanInput, bundleSelectionInput;
  let ctaBtn, ctaPriceEl, ctaLabelEl;
  let mainVariantInput;
  let mainPriceEl, comparePriceEl, saveBadgeEl, perSachetEl;
  let subscribePriceEl, oneTimePriceEl;
  let subtitleEl;

  /* ── Boot ───────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    container = document.querySelector('[data-bundle-v2]');
    if (!container) return;

    // Read bootstrap data
    state.packSize = container.dataset.packSize || '30';
    state.skio.planId = container.dataset.skioPlanId || '';
    state.skio.discountPercent = parseFloat(container.dataset.skioDiscount || '30');

    // Cache DOM
    gallerySlots = Array.from(document.querySelectorAll('.bv2-gallery-slot'));
    builderSlots = Array.from(document.querySelectorAll('.bv2-slot'));
    counterEl = document.getElementById('bv2-counter');
    flavourItems = Array.from(document.querySelectorAll('.bv2-flavour'));
    offerCards = Array.from(document.querySelectorAll('.bv2-offer-card'));
    sellingPlanInput = document.getElementById('bv2-selling-plan');
    ctaBtn = document.getElementById('bv2-cta');
    ctaPriceEl = document.getElementById('bv2-cta-price');
    ctaLabelEl = document.getElementById('bv2-cta-label');
    mainVariantInput = document.querySelector('input[name="id"]');
    mainPriceEl = document.getElementById('bv2-main-price');
    comparePriceEl = document.getElementById('bv2-compare-price');
    saveBadgeEl = document.getElementById('bv2-save-badge');
    perSachetEl = document.getElementById('bv2-per-sachet');
    subscribePriceEl = document.getElementById('bv2-subscribe-price');
    oneTimePriceEl = document.getElementById('bv2-onetime-price');
    subtitleEl = document.getElementById('bv2-subtitle');
    bundleSelectionInput = document.getElementById('bv2-bundle-selection');

    // Parse variant data from pack option elements
    document.querySelectorAll('.bv2-pack-option').forEach(function (el) {
      var id = el.dataset.variantId;
      state.variants[id] = {
        price: parseInt(el.dataset.price, 10) || 0,
        compareAtPrice: parseInt(el.dataset.compareAtPrice, 10) || 0,
        sachets: parseInt(el.dataset.sachets, 10) || 120,
        size: el.dataset.size || '30',
        title: el.dataset.title || '',
      };
    });

    // Seed initial pack size from checked radio
    var checkedPack = document.querySelector('.bv2-pack-option input[type="radio"]:checked');
    if (checkedPack) {
      var packOption = checkedPack.closest('.bv2-pack-option');
      state.packSize = packOption ? (packOption.dataset.size || '30') : '30';
    }

    bindGallerySlots();
    bindBuilderSlots();
    bindFlavourPicker();
    bindPackSelector();
    bindOfferSelector();

    // Store plan ID but don't set it — default is one-time (no selling plan)
    if (sellingPlanInput && state.skio.planId) {
      sellingPlanInput.dataset.planId = state.skio.planId;
      sellingPlanInput.value = '';
    }

    // Highlight one-time card as default active
    offerCards.forEach(function (c) {
      c.classList.toggle('bv2-offer-card--active', c.dataset.offerType === 'onetime');
    });

    state.activeSlot = 0;

    // On mobile: reorder elements
    if (window.matchMedia('(max-width: 989px)').matches) {
      var contentSection = document.querySelector('.custom_contentdesktop');
      var trustBar = document.querySelector('.bv2-trust-bar');
      if (contentSection && trustBar) {
        trustBar.after(contentSection);
      }

      var gallery = document.querySelector('.bv2-gallery');
      var offer = document.querySelector('.bv2-offer');
      if (gallery && offer) {
        offer.after(gallery);
        gallery.style.order = '0';
      }
    }

    render();
    updatePriceDisplay();
  }

  /* ── Gallery (left panel) ───────────────────────────────── */

  function bindGallerySlots() {
    gallerySlots.forEach(function (slot, i) {
      slot.addEventListener('click', function () { setActiveSlot(i); });
    });
  }

  function renderGallery() {
    gallerySlots.forEach(function (slot, i) {
      var flavour = state.slots[i];
      var isActive = state.activeSlot === i;

      slot.classList.toggle('bv2-gallery-slot--active', isActive);
      slot.classList.toggle('bv2-gallery-slot--filled', !!flavour);
      slot.classList.toggle('bv2-gallery-slot--empty', !flavour);

      var img = slot.querySelector('.bv2-gallery-slot__img');
      var badge = slot.querySelector('.bv2-gallery-slot__badge');
      var icon = slot.querySelector('.bv2-gallery-slot__plus');
      var label = slot.querySelector('.bv2-gallery-slot__label');

      if (flavour) {
        if (img) { img.src = flavour.image; img.hidden = false; }
        if (badge) {
          badge.textContent = flavour.title;
          badge.style.background = flavour.badgeColor || '#e0e0e0';
          badge.style.color = flavour.badgeTextColor || '#19262e';
          badge.hidden = false;
        }
        if (icon) icon.hidden = true;
        if (label) label.hidden = true;
      } else {
        if (img) img.hidden = true;
        if (badge) badge.hidden = true;
        if (icon) icon.hidden = false;
        if (label) label.hidden = false;
      }
    });

  }

  /* ── Builder slots (right panel) ────────────────────────── */

  function bindBuilderSlots() {
    builderSlots.forEach(function (slot, i) {
      slot.addEventListener('click', function (e) {
        if (!e.target.closest('.bv2-slot__remove')) {
          setActiveSlot(i);
        }
      });
      var removeBtn = slot.querySelector('.bv2-slot__remove');
      if (removeBtn) {
        removeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          clearSlot(i);
        });
      }
    });
  }

  function renderBuilderSlots() {
    var filled = 0;

    builderSlots.forEach(function (slot, i) {
      var flavour = state.slots[i];
      var isActive = state.activeSlot === i;

      if (flavour) filled++;

      slot.classList.toggle('bv2-slot--active', isActive);
      slot.classList.toggle('bv2-slot--filled', !!flavour);
      slot.classList.toggle('bv2-slot--empty', !flavour);

      var img = slot.querySelector('.bv2-slot__img');
      var badge = slot.querySelector('.bv2-slot__badge');
      var removeBtn = slot.querySelector('.bv2-slot__remove');
      var plusIcon = slot.querySelector('.bv2-slot__plus');
      var label = slot.querySelector('.bv2-slot__label');

      if (flavour) {
        if (img) { img.src = flavour.image; img.hidden = false; }
        if (badge) { badge.textContent = flavour.title; badge.hidden = false; }
        if (removeBtn) removeBtn.hidden = false;
        if (plusIcon) plusIcon.hidden = true;
        if (label) label.hidden = true;
      } else {
        if (img) img.hidden = true;
        if (badge) badge.hidden = true;
        if (removeBtn) removeBtn.hidden = true;
        if (plusIcon) plusIcon.hidden = false;
        if (label) {
          label.textContent = i === 3 ? 'Free Flavour' : 'Flavour ' + (i + 1);
          label.hidden = false;
        }
      }

      // Sync hidden cart input
      var input = slot.querySelector('input[type="hidden"]');
      if (input && input.name.startsWith('items')) {
        input.value = flavour
          ? (state.packSize === '12' ? flavour.id12 : flavour.id30)
          : '';
      }
    });

    if (counterEl) counterEl.textContent = filled + ' of ' + SLOT_COUNT + ' selected';
    return filled;
  }

  /* ── Slot actions ───────────────────────────────────────── */

  function setActiveSlot(i) {
    state.activeSlot = i;
    render();
  }

  function clearSlot(i) {
    state.slots[i] = null;
    // Re-enable main variant input if all cleared
    if (!state.slots.some(Boolean) && mainVariantInput) {
      mainVariantInput.disabled = false;
    }
    render();
  }

  /* ── Flavour Picker ──────────────────────────────────────── */

  function countFlavour(title) {
    return state.slots.filter(function (s) { return s && s.title === title; }).length;
  }

  function addFlavourToSlot(flavourData) {
    var emptyIdx = state.slots.indexOf(null);
    if (emptyIdx === -1) return;
    state.slots[emptyIdx] = flavourData;
    if (mainVariantInput) mainVariantInput.disabled = true;
    var nextEmpty = state.slots.indexOf(null);
    state.activeSlot = nextEmpty !== -1 ? nextEmpty : emptyIdx;
    render();
  }

  function removeFlavourFromSlots(title) {
    for (var i = SLOT_COUNT - 1; i >= 0; i--) {
      if (state.slots[i] && state.slots[i].title === title) {
        state.slots[i] = null;
        break;
      }
    }
    if (!state.slots.some(Boolean) && mainVariantInput) {
      mainVariantInput.disabled = false;
    }
    var firstEmpty = state.slots.indexOf(null);
    if (firstEmpty !== -1) state.activeSlot = firstEmpty;
    render();
  }

  function bindFlavourPicker() {
    flavourItems.forEach(function (item) {
      var only12 = item.dataset.only12 === 'true';
      var flavourData = {
        image: item.dataset.image,
        title: item.dataset.title,
        id12: item.dataset['12'],
        id30: item.dataset['30'],
        badgeColor: item.dataset.badgeColor || '#e0e0e0',
        badgeTextColor: item.dataset.badgeTextColor || '#19262e',
        only12: only12,
      };

      var addBtn = item.querySelector('.bv2-flavour__add');
      var incBtn = item.querySelector('.bv2-flavour__inc');
      var decBtn = item.querySelector('.bv2-flavour__dec');

      function handleAdd(e) {
        e.stopPropagation();
        if (only12 && state.packSize !== '12') return;
        var variantId = state.packSize === '12' ? flavourData.id12 : flavourData.id30;
        if (!variantId) return;
        addFlavourToSlot(flavourData);
      }

      if (addBtn) addBtn.addEventListener('click', handleAdd);
      if (incBtn) incBtn.addEventListener('click', handleAdd);
      if (decBtn) decBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        removeFlavourFromSlots(item.dataset.title);
      });
    });
  }

  function renderPicker() {
    var totalFilled = state.slots.filter(Boolean).length;
    flavourItems.forEach(function (item) {
      var only12 = item.dataset.only12 === 'true';
      var currentVariantId = state.packSize === '12' ? item.dataset['12'] : item.dataset['30'];
      item.style.display = (only12 && state.packSize !== '12') || !currentVariantId ? 'none' : '';

      var count = countFlavour(item.dataset.title);
      var addBtn = item.querySelector('.bv2-flavour__add');
      var stepper = item.querySelector('.bv2-flavour__stepper');
      var countEl = item.querySelector('.bv2-flavour__count');
      var incBtn = item.querySelector('.bv2-flavour__inc');

      if (addBtn) { addBtn.hidden = count > 0; addBtn.disabled = totalFilled >= SLOT_COUNT; }
      if (stepper) stepper.hidden = count === 0;
      if (countEl) countEl.textContent = count;
      if (incBtn) incBtn.disabled = totalFilled >= SLOT_COUNT;
    });
  }

  /* ── Pack selector ───────────────────────────────────────── */

  function bindPackSelector() {
    document.querySelectorAll('.bv2-pack-option').forEach(function (option) {
      var radio = option.querySelector('input[type="radio"]');
      if (!radio) return;

      option.addEventListener('click', function () {
        if (radio.checked) return; // already selected
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });

      radio.addEventListener('change', function () {
        var newSize = option.dataset.size || '30';
        state.packSize = newSize;

        // Update active styling
        document.querySelectorAll('.bv2-pack-option').forEach(function (o) {
          o.classList.toggle('bv2-pack-option--active', o.dataset.variantId === radio.value);
        });

        // Update subtitle
        updateSubtitle(option);

        // Clear any 12-pack-only flavours if switching to 30-pack
        if (newSize !== '12') {
          state.slots = state.slots.map(function (s) {
            return s && s.only12 ? null : s;
          });
        }

        // Sync variant IDs already in slots
        syncHiddenInputs();

        // Update price display
        updatePriceDisplay();

        // Fire Dawn-compatible variant change event
        var variantData = state.variants[radio.value];
        if (variantData) {
          document.dispatchEvent(new CustomEvent('variant:change', {
            bubbles: true,
            detail: {
              variant: {
                id: parseInt(radio.value, 10),
                price: variantData.price,
                compare_at_price: variantData.compareAtPrice,
                title: variantData.title,
              },
            },
          }));
        }

        render();
      });
    });
  }

  function updateSubtitle(activeOption) {
    if (!subtitleEl) return;
    var sachets = parseInt(activeOption.dataset.sachets, 10) || 120;
    subtitleEl.textContent = sachets + ' sachets · 4 boxes · mix any flavours';
  }

  /* ── Offer selector ──────────────────────────────────────── */

  function bindOfferSelector() {
    offerCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var type = card.dataset.offerType;
        if (state.offerType === type) return;
        state.offerType = type;

        offerCards.forEach(function (c) {
          c.classList.toggle('bv2-offer-card--active', c.dataset.offerType === type);
        });

        var radio = card.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        // Populate / clear selling plan
        if (sellingPlanInput) {
          sellingPlanInput.value = type === 'subscribe' ? (sellingPlanInput.dataset.planId || '') : '';
        }

        updatePriceDisplay();
        updateCta();
      });
    });
  }

  /* ── Price display ───────────────────────────────────────── */

  function updatePriceDisplay() {
    var checkedRadio = document.querySelector('.bv2-pack-option input[type="radio"]:checked');
    if (!checkedRadio) return;

    var variantData = state.variants[checkedRadio.value];
    if (!variantData) return;

    var oneTimePrice = variantData.price;
    var compareAt = variantData.compareAtPrice;
    var discountFraction = state.skio.discountPercent / 100;
    var basePrice = compareAt > 0 ? compareAt : oneTimePrice;
    var subscribePrice = Math.round(basePrice * (1 - discountFraction));
    var sachets = variantData.sachets;

    var isSubscribe = state.offerType === 'subscribe';
    var activePrice = isSubscribe ? subscribePrice : oneTimePrice;
    var saved = basePrice - activePrice;

    // Main price block
    if (mainPriceEl) mainPriceEl.textContent = formatMoney(activePrice);
    if (comparePriceEl) {
      var showCompare = compareAt > 0;
      comparePriceEl.textContent = showCompare ? formatMoney(compareAt) : '';
      comparePriceEl.hidden = !showCompare;
    }
    if (saveBadgeEl) {
      var showSave = compareAt > 0;
      saveBadgeEl.textContent = showSave ? 'Save ' + formatMoney(saved) : '';
      saveBadgeEl.hidden = !showSave;
    }
    if (perSachetEl) {
      var perSachetLabel = isSubscribe ? ' per sachet · subscribed price shown' : ' per sachet';
      perSachetEl.textContent = formatMoney(Math.round(activePrice / sachets)) + perSachetLabel;
    }

    // Offer card prices
    if (subscribePriceEl) subscribePriceEl.textContent = formatMoney(subscribePrice);
    if (oneTimePriceEl) oneTimePriceEl.textContent = formatMoney(oneTimePrice);

    // Pack option card prices — mirror the active offer type
    document.querySelectorAll('.bv2-pack-option').forEach(function (option) {
      var rrp = parseInt(option.dataset.compareAtPrice, 10) || 0;
      var oneTime = parseInt(option.dataset.price, 10) || 0;
      var base = rrp > 0 ? rrp : oneTime;
      var subPrice = Math.round(base * (1 - discountFraction));

      var priceEl = option.querySelector('.bv2-pack-price');
      var compareEl = option.querySelector('.bv2-pack-compare');

      if (isSubscribe) {
        if (priceEl) priceEl.textContent = formatMoney(subPrice);
        if (compareEl) compareEl.textContent = formatMoney(oneTime);
      } else {
        if (priceEl) priceEl.textContent = formatMoney(oneTime);
        if (compareEl) compareEl.textContent = formatMoney(rrp);
      }
    });

    updateCta(activePrice);
  }

  /* ── CTA ─────────────────────────────────────────────────── */

  function updateCta(priceOverride) {
    var filled = state.slots.filter(Boolean).length;
    var allFilled = filled === SLOT_COUNT;

    if (ctaBtn) ctaBtn.disabled = !allFilled;

    if (ctaLabelEl) {
      ctaLabelEl.textContent = state.offerType === 'subscribe'
        ? 'Subscribe and save'
        : (ctaBtn ? (ctaBtn.getAttribute('aria-label') || 'Add bundle to cart') : 'Add bundle to cart');
    }

    if (ctaPriceEl) {
      if (priceOverride !== undefined) {
        ctaPriceEl.textContent = formatMoney(priceOverride);
      } else {
        // Recalculate
        var checkedRadio = document.querySelector('.bv2-pack-option input[type="radio"]:checked');
        if (checkedRadio) {
          var variantData = state.variants[checkedRadio.value];
          if (variantData) {
            var base = variantData.compareAtPrice > 0 ? variantData.compareAtPrice : variantData.price;
            var p = state.offerType === 'subscribe'
              ? Math.round(base * (1 - state.skio.discountPercent / 100))
              : variantData.price;
            ctaPriceEl.textContent = formatMoney(p);
          }
        }
      }
    }
  }

  /* ── Sync hidden inputs ─────────────────────────────────── */

  function syncHiddenInputs() {
    builderSlots.forEach(function (slot, i) {
      var input = slot.querySelector('input[type="hidden"]');
      var flavour = state.slots[i];
      if (input && input.name.startsWith('items')) {
        input.value = flavour
          ? (state.packSize === '12' ? flavour.id12 : flavour.id30)
          : '';
      }
    });
    syncBundleSelectionProperty();
  }

  function syncBundleSelectionProperty() {
    if (!bundleSelectionInput) return;
    bundleSelectionInput.value = state.slots
      .map(function (s) { return s ? s.title : null; })
      .filter(Boolean)
      .join(', ');
  }

  /* ── Master render ───────────────────────────────────────── */

  function render() {
    renderGallery();
    renderBuilderSlots();
    renderPicker();
    updateCta();
    syncBundleSelectionProperty();
  }

  /* ── Helpers ─────────────────────────────────────────────── */

  function formatMoney(cents) {
    if (isNaN(cents)) return '';
    var dollars = cents / 100;
    return '$' + dollars.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

})();
